import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const productImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/6sBGBYCa6jMTajsGcXkzE1/foto_p_y_g.png',
  alt: 'AirGuard Pro Plug & Play',
  label: 'Plug & Play'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h8d5KrvbawiAKLAe7vYXkJ/gif_seguro_000ppm.gif',
  alt: 'Product Demo GIF',
  label: 'Product Demo GIF'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4WMQgH3pDUPaPv7PP6iAuM/foto5.png',
  alt: 'AirGuard Pro 4-stage alert display',
  label: 'Alert System'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gj1rw79pLwUdV7BE5RRaiG/foto1.png',
  alt: 'AirGuard Pro in room contexts',
  label: 'In Your Home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vExBLuKVZ1VHvAJJPFFsLz/foto2.png',
  alt: 'AirGuard Pro sensor internals',
  label: 'Sensor Detail'
}];
export function HeroSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  return <section className="w-full bg-bg-primary py-6 md:py-10 px-4 sm:px-6 lg:px-8" data-id="element-220">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[55%_45%] gap-6 lg:gap-10 items-center" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center lg:items-start lg:text-left order-1" data-id="element-222">
          <span className="text-text-secondary font-medium text-[13px] tracking-wide uppercase mb-2.5" data-id="element-223">
            AirGuard Technologies — Professional CO Protection
          </span>

          <h1 className="text-[32px] md:text-[48px] font-bold text-text-primary leading-[1.1] mb-4 text-center w-full" data-id="element-224">
            Your Family Has Been Breathing Poison. Your Detector Never Said a
            Word.
          </h1>

          <p className="text-[16px] md:text-[18px] text-text-secondary mb-5 leading-[1.45] text-justify" data-id="element-225">
            Standard CO detectors only alarm at near-fatal levels.{' '}
            <strong className="text-text-primary" data-id="element-226">
              AirGuard Pro alerts you at 30+ PPM — hours before you're in
              danger.
            </strong>{' '}
            See the exact level in real time on a crisp 2-inch color display.
          </p>

          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2.5 mb-5 text-[13px] font-medium text-text-secondary" data-id="element-227">
            <div className="flex items-center gap-1.5" data-id="element-228">
              <CheckCircle2 className="w-4 h-4 text-accent-green" data-id="element-229" />
              <span data-id="element-230">CE & FCC Certified</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-231">
              <CheckCircle2 className="w-4 h-4 text-accent-green" data-id="element-232" />
              <span data-id="element-233">3-Year Warranty</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-234">
              <CheckCircle2 className="w-4 h-4 text-accent-green" data-id="element-235" />
              <span data-id="element-236">30-Day Money-Back</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-237">
              <CheckCircle2 className="w-4 h-4 text-accent-green" data-id="element-238" />
              <span data-id="element-239">Free Shipping</span>
            </div>
          </div>

          {/* Product Image Slider — after badges, before CTA */}
          <div className="w-full mb-5" data-id="element-240">
            <div className="relative w-full aspect-square rounded-xl border border-border-subtle shadow-card overflow-hidden mb-2.5 bg-gray-50" data-id="element-241">
              <AnimatePresence mode="wait" data-id="element-242">
                <motion.img key={activeIndex} src={productImages[activeIndex].src} alt={productImages[activeIndex].alt} initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="w-full h-full object-contain" data-id="element-243" />
              </AnimatePresence>
            </div>
            <div className="flex gap-1.5 overflow-x-auto pb-1" data-id="element-244">
              {productImages.map((img, i) => <button key={i} onClick={() => setActiveIndex(i)} className={`flex-shrink-0 w-[56px] h-[56px] rounded-lg border-2 overflow-hidden transition-all duration-200 bg-gray-50 ${activeIndex === i ? 'border-accent-orange shadow-sm' : 'border-border-subtle hover:border-gray-300'}`} data-id="element-245">
                  <img src={img.src} alt={img.label} className="w-full h-full object-contain" data-id="element-246" />
                </button>)}
            </div>
          </div>

          <div className="flex flex-col items-center lg:items-start w-full" data-id="element-247">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto bg-accent-orange hover:brightness-110 text-white font-bold text-[16px] uppercase py-[18px] px-10 rounded-lg transition-all duration-300 mb-3" data-id="element-248">
              PROTECT MY FAMILY NOW
            </button>
            <span className="text-[12px] text-text-secondary" data-id="element-249">
              Join 4,800+ families who stopped guessing.
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="order-2" data-id="element-250">
          <img src="https://cdn.magicpatterns.com/uploads/9S7Hjz5L4YqJtNup4di4u4/fotoproductosocialproof.png" alt="Mother watching over sleeping child with CO monitor glowing green" className="w-full h-auto rounded-xl shadow-card object-cover" data-id="element-251" />
        </motion.div>
      </div>
    </section>;
}